import { toast } from 'react-toastify';
import { i18n } from '../translate/i18n';
import { isString } from 'lodash';

const toastError = (err) => {
  const errorMsg =
    err.response?.data?.error ||
    err.props.children ||
    err.response?.data?.message;
  if (errorMsg) {
    if (i18n.exists(`backendErrors.${errorMsg}`)) {
      toast.error(
        <div
          style={{
            whiteSpace: 'pre-line',
            textAlign: 'center',
            paddingRight: '25px',
          }}
        >
          {i18n.t(`backendErrors.${errorMsg}`)}
        </div>,
        {
          toastId: errorMsg,
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        },
      );
      return;
    } else {
      toast.error(
        <div
          style={{
            whiteSpace: 'pre-line',
            textAlign: 'center',
            paddingRight: '25px',
          }}
        >
          {errorMsg}
        </div>,
        {
          toastId: errorMsg,
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'dark',
        },
      );
      return;
    }
  }
  if (isString(err)) {
    toast.error(
      <div
        style={{
          whiteSpace: 'pre-line',
          textAlign: 'center',
          paddingRight: '25px',
        }}
      >
        {err}
      </div>,
      {
        toastId: errorMsg,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      },
    );
    return;
  } else {
    toast.error(
      <div
        style={{
          whiteSpace: 'pre-line',
          textAlign: 'center',
          paddingRight: '25px',
        }}
      >
        {'An error occurred!'}
      </div>,
      {
        toastId: errorMsg,
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'dark',
      },
    );
    return;
  }
};

export default toastError;
